import { useCallback } from "react";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { useUniqueId } from "../Utils/uniqueId";
import { useInputAriaDescribedBy } from "../Form/useInputAriaDescribedBy";
import { ANSWER_CHOICE_VALUE_OTHER } from "../Answer/AnswerChoiceWithOther";

const OtherField = props => {
  const {
    fieldName,
    inputType,
    other,
    otherValue,
    otherFieldLabel,
    onChange,
    displayOtherField,
    disabled
  } = props;

  const inputId = useUniqueId("option-input-");
  const otherInputId = useUniqueId("option-input-");

  const ariaDescribedBy = useInputAriaDescribedBy();

  const handleOtherTextFieldChanged = useCallback(
    e => onChange({ otherValue: e.target.value }),
    [onChange]
  );

  const handleOtherFieldChanged = useCallback(
    e => onChange({ other: e.target.checked }),
    [onChange]
  );

  const t = useFormatMessage();
  const otherTextSrLabel = t(intlMessages.otherTextSrLabel);

  if (!displayOtherField) return null;

  const className = classNames("form-check", "form-check-other", {
    "form-check-selected": other
  });

  return (
    <div className={className}>
      <label className="form-check-label" htmlFor={inputId}>
        <input
          id={inputId}
          type={inputType}
          className="form-check-input"
          value={ANSWER_CHOICE_VALUE_OTHER}
          name={fieldName}
          onChange={handleOtherFieldChanged}
          checked={other}
          disabled={disabled}
          aria-describedby={ariaDescribedBy}
        />

        <span className="form-check-label-inner">{otherFieldLabel}</span>
      </label>

      {other && (
        <label className="form-check-other padding-sm d-block" htmlFor={otherInputId}>
          <span className="sr-only">{otherTextSrLabel}</span>
          <input
            id={otherInputId}
            type="text"
            className="form-control"
            name="otherValue"
            value={otherValue}
            onChange={handleOtherTextFieldChanged}
            aria-describedby={ariaDescribedBy}
          />
        </label>
      )}
    </div>
  );
};

const intlMessages = defineMessages({
  otherTextSrLabel: {
    id: "inputs.otherField.otherTextSrLabel",
    defaultMessage: "Autre, précisez:"
  }
});

export default OtherField;
